import React, { useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Grid, GridItem, Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { DomestikaLiveSpinner } from "@domestika-dev/prudencio/dist/atoms/DomestikaLiveSpinner";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { LiveSessionContext } from "../../../context/LiveSessionContext";
import { getAssetPath } from "../../../utils/assetsUtils";

export const PlayerLobby = ({ height, width }) => {
  const { course } = useContext(LiveSessionContext);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height={height}
      width={width}
      color="white"
      style={{
        backgroundImage: `url(${getAssetPath(course?.livePlaceholder)})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <Grid gridTemplateColumns="1fr" style={{ alignItems: "center", width }}>
        <GridItem gridColumn="1" gridRow="1">
          <Flex backgroundColor="sonar" height={height} width={width} opacity={0.8} />
        </GridItem>
        <GridItem gridColumn="1" gridRow="1">
          <Flex height={height} width={width} justifyContent="center" alignItems="center">
            <Grid gridRowGap={[6, 6, 6]} gridTemplateColumns="1fr" style={{ alignItems: "center" }}>
              <GridItem gridColumn="1" gridRow="1">
                <Flex justifyContent="center">
                  <DomestikaLiveSpinner />
                </Flex>
              </GridItem>
              <GridItem gridColumn="1" gridRow="2">
                <Text size="small" textAlign="center" color="coco">
                  <FormattedMessage id="live_sessions.waiting_room_message" />
                </Text>
              </GridItem>
            </Grid>
          </Flex>
        </GridItem>
      </Grid>
    </Flex>
  );
};

PlayerLobby.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
};

export default PlayerLobby;
